export enum ButtonLabel {
    OUT_OF_STOCK = 'Out of stock',
    SELECT_A_VARIANT = 'Select a variant',
    ADD_TO_CART = 'Add to cart',
    UPDATE_CART_ITEM = 'Update',
    BUY_NOW = 'Buy Now'
}
